/**
 * 运费险
 */
(function () {
  if (window.__SP_INSURANCE_GLOBAL_V3__) return;
  window.__SP_INSURANCE_GLOBAL_V3__ = true;

  const KEY_FROM_CHECKOUT = '__sp_insurance_from_checkout__';
  const KEY_INSURANCE_PID = '__sp_insurance_pid__';
  const KEY_CART_RELOADED = '__sp_insurance_cart_reloaded__';

  let config = null; // { productId, variants:[{id, price}] }
  let toggleState = false; // 默认关闭
  let pickedVariant = null;
  let lastBaseTotalCents = 0;
  let currentDisplayPriceText = '0';

  const originalFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!originalFetch) return;

  let internalCartFetchDepth = 0;
  let syncing = false;
  let syncTimer = null;
  let cleanupRunning = false;

  function hasWidgetInDom() {
    return !!document.querySelector('.shipping-protection');
  }

  // 将弹窗遮罩移到 body，避免被购物车抽屉的 transform/overflow 限制。
  function mountTipMaskToBody() {
    document.querySelectorAll('.sp-tip-mask').forEach(mask => {
      if (mask.parentElement !== document.body) {
        document.body.appendChild(mask);
      }
    });
  }

  function persistInsuranceProductId(productId) {
    const pid = Number(productId);
    if (!Number.isFinite(pid)) return;
    try { sessionStorage.setItem(KEY_INSURANCE_PID, String(pid)); } catch (e) {}
    try { localStorage.setItem(KEY_INSURANCE_PID, String(pid)); } catch (e) {}
  }

  function getStoredInsuranceProductId() {
    let pid = NaN;
    try { pid = Number(sessionStorage.getItem(KEY_INSURANCE_PID)); } catch (e) {}
    if (!Number.isFinite(pid)) {
      try { pid = Number(localStorage.getItem(KEY_INSURANCE_PID)); } catch (e) {}
    }
    return Number.isFinite(pid) ? pid : null;
  }

  function getInsuranceProductId() {
    if (config && Number.isFinite(Number(config.productId))) return Number(config.productId);
    return getStoredInsuranceProductId();
  }

  function setAllToggles(checked) {
    document.querySelectorAll('#sp_toggle').forEach(el => {
      if (el.checked !== !!checked) el.checked = !!checked;
    });
  }

  function setAllPriceText(text) {
    currentDisplayPriceText = text;
    document.querySelectorAll('#sp_calc_price').forEach(el => {
      if (el.textContent !== text) el.textContent = text;
    });
    document.querySelectorAll('#sp_calc_price_tip').forEach(el => {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function formatPriceText(n) {
    const v = Number(n);
    if (!Number.isFinite(v) || v <= 0) return '0';
    return v.toFixed(2);
  }

  function readConfigFromDom() {
    const els = document.querySelectorAll('[data-sp-insurance-config]');
    if (!els || !els.length) return null;

    for (const el of els) {
      try {
        const parsed = JSON.parse(el.textContent || '{}');
        const productId = Number(parsed.productId);
        const variants = Array.isArray(parsed.variants) ? parsed.variants : [];
        const normalized = variants
          .map(v => ({ id: Number(v.id), price: Number(v.price) }))
          .filter(v => Number.isFinite(v.id) && Number.isFinite(v.price))
          .sort((a, b) => a.price - b.price);

        if (!Number.isFinite(productId) || normalized.length === 0) continue;
        return { productId, variants: normalized };
      } catch (e) {}
    }
    return null;
  }

  function ensureConfig() {
    if (config) return true;
    const c = readConfigFromDom();
    if (c) {
      config = c;
      persistInsuranceProductId(config.productId);
      return true;
    }
    return false;
  }

  function pickVariantByExpected(expectedPrice) {
    if (!config || !config.variants.length) return null;
    return config.variants.find(v => v.price >= expectedPrice) || config.variants[config.variants.length - 1];
  }

  function calculateAndRender(baseTotalCents) {
    if (!ensureConfig()) return;

    const cents = Number(baseTotalCents) || 0;
    if (cents <= 0) {
      pickedVariant = null;
      setAllPriceText('0');
      return;
    }
    // 运费险率按照2%
    const expected = (cents / 100) * 0.02;
    const chosen = pickVariantByExpected(expected);
    pickedVariant = chosen;
    setAllPriceText(chosen ? formatPriceText(chosen.price) : '0');
  }

  async function fetchCart() {
    internalCartFetchDepth++;
    try {
      const res = await originalFetch('/cart.js', { credentials: 'same-origin' });
      return await res.json();
    } finally {
      internalCartFetchDepth--;
    }
  }

  async function postJSON(url, body) {
    const res = await originalFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body || {})
    });
    if (!res.ok) throw new Error(url + ' ' + res.status);
    try { return await res.json(); } catch (e) { return null; }
  }

  function baseTotalCentsExcludingInsurance(cart) {
    const pid = getInsuranceProductId();
    if (!pid) return Number(cart?.total_price || 0);

    const items = Array.isArray(cart?.items) ? cart.items : [];
    let sum = 0;
    for (const item of items) {
      if (Number(item?.product_id) === pid) continue;
      sum += Number(item?.final_line_price || 0);
    }
    return sum;
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncFromCart, 180);
  }

  async function syncFromCart() {
    if (syncing) return;
    syncing = true;
    try {
      ensureConfig();
      const cart = await fetchCart();
      lastBaseTotalCents = baseTotalCentsExcludingInsurance(cart);
      calculateAndRender(lastBaseTotalCents);
      setAllToggles(toggleState);
      setAllPriceText(currentDisplayPriceText);
    } catch (e) {
    } finally {
      syncing = false;
    }
  }

  function normalizePath(urlLike) {
    try {
      const u = new URL(String(urlLike), location.origin);
      return u.pathname;
    } catch (e) {
      const s = String(urlLike || '');
      return s.startsWith('/') ? s : ('/' + s);
    }
  }

  function isCartRelated(urlLike) {
    const p = normalizePath(urlLike);
    return (
      p === '/cart.js' ||
      p === '/cart/add.js' || p === '/cart/add' ||
      p === '/cart/change.js' || p === '/cart/change' ||
      p === '/cart/update.js' || p === '/cart/update' ||
      p === '/cart/clear.js' || p === '/cart/clear'
    );
  }

  // hook fetch：同步价格
  if (!window.__SP_INSURANCE_FETCH_HOOKED_GLOBAL_V3__) {
    window.__SP_INSURANCE_FETCH_HOOKED_GLOBAL_V3__ = true;
    const realFetch = originalFetch;

    window.fetch = function (...args) {
      const p = realFetch(...args);
      p.then(() => {
        try {
          const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
          if (internalCartFetchDepth > 0 && normalizePath(url) === '/cart.js') return;
          if (isCartRelated(url)) scheduleSync();
        } catch (e) {}
      }, () => {});
      return p;
    };
  }

  // hook XHR：兼容主题
  (function hookXHR() {
    if (window.__SP_INSURANCE_XHR_HOOKED_GLOBAL_V3__) return;
    window.__SP_INSURANCE_XHR_HOOKED_GLOBAL_V3__ = true;

    const XHR = window.XMLHttpRequest;
    if (!XHR) return;

    const origOpen = XHR.prototype.open;
    const origSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url, ...rest) {
      this.__sp_url__ = url;
      return origOpen.call(this, method, url, ...rest);
    };

    XHR.prototype.send = function (...sendArgs) {
      this.addEventListener('loadend', () => {
        try {
          if (isCartRelated(this.__sp_url__)) scheduleSync();
        } catch (e) {}
      });
      return origSend.apply(this, sendArgs);
    };
  })();

  // DOM observer：模块/配置插入时同步一次
  const domObserver = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const n of m.addedNodes || []) {
        if (!n || n.nodeType !== 1) continue;
        const el = n;
        if (
          el.matches?.('[data-sp-insurance-config], .shipping-protection, .t4s-mini_cart__item, .t4s-page_cart__item') ||
          el.querySelector?.('[data-sp-insurance-config], .shipping-protection, .t4s-mini_cart__item, .t4s-page_cart__item')
        ) {
          mountTipMaskToBody();
          ensureConfig();
          setAllToggles(toggleState);
          setAllPriceText(currentDisplayPriceText);
          scheduleSync();
          // cart 页面上也触发一次清理（进入 cart 后 config 往往是异步插入的）
          if (location.pathname === '/cart') scheduleCartCleanup({ reason: 'dom-insert' });
          return;
        }
      }
    }
  });
  domObserver.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // toggle：事件委托
  document.addEventListener('change', function (e) {
    const t = e.target;
    if (!t || t.id !== 'sp_toggle') return;
    toggleState = !!t.checked;
    setAllToggles(toggleState);
  }, true);

  // 弹窗：事件委托
  function findTipMask(spEl) {
    if (!spEl) return null;

    let node = spEl.nextElementSibling;
    while (node) {
      if (node.classList && node.classList.contains('sp-tip-mask')) {
        document.body.appendChild(node);
        return node;
      }
      if (node.classList && node.classList.contains('shipping-protection')) break;
      node = node.nextElementSibling;
    }

    const parent = spEl.parentElement;
    const localMask = parent ? parent.querySelector('.sp-tip-mask') : null;
    if (localMask) {
      document.body.appendChild(localMask);
      return localMask;
    }

    // 遮罩已经挂载到 body 时，直接从 body 中获取。
    return document.querySelector('body > .sp-tip-mask');
  }

  document.addEventListener('click', function (e) {
    const opener = e.target && e.target.closest ? e.target.closest('.shipping-protection .sp-title span') : null;
    if (opener) {
      const sp = opener.closest('.shipping-protection');
      const mask = findTipMask(sp);
      if (mask) mask.style.display = 'flex';
      return;
    }

    const closeBtn = e.target && e.target.closest ? e.target.closest('.sp-tip-btn, .sp-tip-close-icon') : null;
    if (closeBtn) {
      const mask = closeBtn.closest('.sp-tip-mask');
      if (mask) mask.style.display = 'none';
      return;
    }

    const bg = e.target && e.target.classList && e.target.classList.contains('sp-tip-mask') ? e.target : null;
    if (bg) bg.style.display = 'none';
  }, true);

  // ====== 核心：进入 /cart 就清理运费险（并在删除成功后 reload 一次）======
  function scheduleCartCleanup(opts) {
    // 防抖一下，避免 /cart 渲染期间多次触发
    if (scheduleCartCleanup._t) clearTimeout(scheduleCartCleanup._t);
    scheduleCartCleanup._t = setTimeout(() => cartCleanup(opts), 120);
  }

  async function cartCleanup(opts) {
    if (location.pathname !== '/cart') return;
    if (cleanupRunning) return;
    cleanupRunning = true;

    const maxAttempts = 8;
    const attemptDelayMs = 250;

    try {
      for (let attempt = 1; attempt <= maxAttempts; attempt++) {
        ensureConfig();
        const pid = getInsuranceProductId();

        if (!pid) {
          await new Promise(r => setTimeout(r, attemptDelayMs));
          continue;
        }

        const cart = await fetchCart();
        const items = Array.isArray(cart?.items) ? cart.items : [];
        const insuranceItems = items.filter(i => Number(i?.product_id) === pid);

        // 没有运费险：如果是从 checkout 回来，清理标记即可
        if (!insuranceItems.length) {
          try { sessionStorage.removeItem(KEY_FROM_CHECKOUT); } catch (e) {}
          return;
        }

        // 有运费险：删掉（用 update.js 一次性删所有相关 variant）
        const updates = {};
        for (const it of insuranceItems) updates[it.id] = 0;

        await postJSON('/cart/update.js', { updates });

        // 再确认一次是否已删除
        const cart2 = await fetchCart();
        const items2 = Array.isArray(cart2?.items) ? cart2.items : [];
        const stillHas = items2.some(i => Number(i?.product_id) === pid);

        if (!stillHas) {
          // 删除完成：清 flag，然后刷新一次 UI（只刷新一次，避免循环）
          try { sessionStorage.removeItem(KEY_FROM_CHECKOUT); } catch (e) {}

          let reloaded = false;
          try { reloaded = sessionStorage.getItem(KEY_CART_RELOADED) === '1'; } catch (e) {}
          if (!reloaded) {
            try { sessionStorage.setItem(KEY_CART_RELOADED, '1'); } catch (e) {}
            location.reload();
          } else {
            // 如果已经刷新过一次，就不再 reload，避免极端情况下循环
            scheduleSync();
          }
          return;
        }

        // 还没删掉：等一会儿重试
        await new Promise(r => setTimeout(r, attemptDelayMs));
      }
    } finally {
      cleanupRunning = false;
    }
  }

  // 每次进入 /cart 都检查
  function onCartPageShow() {
    if (location.pathname !== '/cart') {
      try { sessionStorage.removeItem(KEY_CART_RELOADED); } catch (e) {}
      return;
    }
    // 进入 cart 新页面：允许 reload 一次
    try { sessionStorage.removeItem(KEY_CART_RELOADED); } catch (e) {}
    scheduleCartCleanup({ reason: 'cart-pageshow' });
  }

  window.addEventListener('pageshow', onCartPageShow);
  onCartPageShow();

  // ====== checkout：结账前加购 ======
  let checkoutProcessing = false;

  async function ensureInsuranceBeforeCheckout() {
    if (!toggleState) return;
    if (!ensureConfig()) return;

    persistInsuranceProductId(config.productId);

    if (!pickedVariant || !pickedVariant.id || lastBaseTotalCents <= 0) return;

    // 只有要加购时才设置“回站删除”标记
    try { sessionStorage.setItem(KEY_FROM_CHECKOUT, '1'); } catch (e) {}

    const cart = await fetchCart();
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const pid = Number(config.productId);

    const insuranceItems = items.filter(i => Number(i?.product_id) === pid);
    const hasRight = insuranceItems.some(i => Number(i?.id) === Number(pickedVariant.id));

    if (!hasRight && insuranceItems.length) {
      const updates = {};
      for (const it of insuranceItems) updates[it.id] = 0;
      await postJSON('/cart/update.js', { updates });
    }

    if (!hasRight) {
      await postJSON('/cart/add.js', { id: pickedVariant.id, quantity: 1 });
    }
  }

  function isCheckoutTarget(target) {
    if (!target) return false;
    if (target.matches && target.matches('button[name="checkout"], input[name="checkout"]')) return true;
    if (target.tagName === 'A') return (target.getAttribute('href') || '').includes('/checkout');
    return false;
  }

  document.addEventListener('click', function (e) {
    if (!hasWidgetInDom()) return;

    const target = e.target && e.target.closest
      ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]')
      : null;
    if (!isCheckoutTarget(target)) return;

    if (target.tagName === 'A') {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    }

    e.preventDefault();
    if (checkoutProcessing) return;
    checkoutProcessing = true;

    ensureInsuranceBeforeCheckout()
      .catch(() => {})
      .finally(() => { location.href = '/checkout'; });
  }, true);

  document.addEventListener('submit', function (e) {
    if (!hasWidgetInDom()) return;

    const form = e.target;
    const action = (form && form.action) ? String(form.action) : '';
    if (!action.includes('/checkout')) return;

    e.preventDefault();
    if (checkoutProcessing) return;
    checkoutProcessing = true;

    ensureInsuranceBeforeCheckout()
      .catch(() => {})
      .finally(() => { location.href = '/checkout'; });
  }, true);

  // checkout 返回：直接跳 /cart（让 /cart 的“强制清理”接管）
  async function handleReturnFromCheckout() {
    let need = false;
    try { need = sessionStorage.getItem(KEY_FROM_CHECKOUT) === '1'; } catch (e) {}
    if (!need) return;

    if (location.pathname !== '/cart') {
      location.replace('/cart?sp_return=' + Date.now());
    } else {
      scheduleCartCleanup({ reason: 'return-from-checkout' });
    }
  }

  window.addEventListener('pageshow', handleReturnFromCheckout);
  handleReturnFromCheckout();

  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountTipMaskToBody);
  } else {
    mountTipMaskToBody();
  }

  setAllToggles(false);
  setAllPriceText('0');
  scheduleSync();
})();
